/*
 * @Author: kian
 * @Date: 2021-11-09 10:29:28
 * @LastEditors: kian
 * @LastEditTime: 2021-11-13 10:31:09
 * @Description:
 */
import { GetAdByType } from '~/api/ad';
export default {
  data() {
    return {
      live_ad: {
        position_1: null,
        position_2: null,
      },
      news_ad: {
        position_1: null,
        position_2: null,
      },
      subjectList_ad: {
        position_1: null,
        position_2: null,
      },
      subjectDetail_ad: {
        position_1: null,
        position_2: null,
      },
      column_ad: {
        position_1: null,
        position_2: null,
      },
    };
  },

  mounted() {
    this.judgePage();
  },

  methods: {
    judgePage() {
      const routeName = this.$route.name;
      switch (routeName) {
        case 'live':
          this.getListAd(12);
          this.getListAd(13);
          break;
        case 'news':
          this.getListAd(14);
          this.getListAd(15);
          break;
        case 'subject':
          this.getListAd(16);
          this.getListAd(17);
          break;
        case 'subject-id':
          this.getListAd(18);
          this.getListAd(19);
          break;
        case 'column':
          this.getListAd(20);
          this.getListAd(21);
          break;
      }
    },
    getListAd(type) {
      this.$axios(GetAdByType(type)).then((res) => {
        switch (type) {
          case 12:
            this.live_ad.position_1 = res?.result?.[0]
              ? Object.assign(
                  { isAd: true, isnewDate: false },
                  res?.result?.[0]
                )
              : null;
            break;
          case 13:
            this.live_ad.position_2 = res?.result?.[0]
              ? Object.assign(
                  { isAd: true, isnewDate: false },
                  res?.result?.[0]
                )
              : null;
            break;
          case 14:
            this.news_ad.position_1 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 15:
            this.news_ad.position_2 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 16:
            this.subjectList_ad.position_1 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 17:
            this.subjectList_ad.position_2 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 18:
            this.subjectDetail_ad.position_1 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 19:
            this.subjectDetail_ad.position_2 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 20:
            this.column_ad.position_1 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
          case 21:
            this.column_ad.position_2 = res?.result?.[0]
              ? Object.assign({ isAd: true }, res?.result?.[0])
              : null;
            break;
        }
      });
    },
    insertAdToData(data, adData, pos_1, pos_2) {
      try {
        let dataWithAd = data;

        if (data.length >= pos_1 && adData.position_1) {
          dataWithAd = [
            ...data.slice(0, pos_1),
            adData.position_1,
            ...data.slice(pos_1),
          ];
        }

        if (data.length >= pos_2 && adData.position_2) {
          if (adData.position_1) {
            dataWithAd = [
              ...dataWithAd.slice(0, pos_2 + 1),
              adData.position_2,
              ...dataWithAd.slice(pos_2 + 1),
            ];
          } else {
            dataWithAd = [
              ...dataWithAd.slice(0, pos_2),
              adData.position_2,
              ...dataWithAd.slice(pos_2),
            ];
          }
        }

        return dataWithAd;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return [];
      }
    },
  },
};
